import styled from "styled-components";
export var DragItem = styled.div.withConfig({
  displayName: "dragItemstyles__DragItem",
  componentId: "sc-1x7k355-0"
})(["", ""], function (_ref) {
  var isDragging = _ref.isDragging;
  return "\n    opacity: ".concat(isDragging ? 0 : 1, ";\n  ");
});